import React, { useState, useMemo } from "react";
import "./index.css";
import section2img from "../assests/HomeImg/section2-img.svg";

// ── Imported PDFs ─────────────────────────────────────────────────────────────
import ESOPDisclosure202526 from "../assests/AnnualReportsPdf/ESOP-Disclosure-2025-26-1.pdf";
import AnnualPdf202526 from "../assests/AnnualReportsPdf/Annual-Report-FY-2025-26.pdf";
import BRSReport202526 from "../assests/AnnualReportsPdf/BRSR 2025-2026.pdf";
import MGT7_202526 from "../assests/AnnualReportsPdf/MGT-7 2025-2026.pdf";
import DraftViyashAOA2526 from "../assests/AnnualReportsPdf/DraftVIYASHAOA.pdf";



import AnnualPdf1 from "../assests/AnnualReportsPdf/MGT-7 2024-25.pdf";
import AnnualPdf2 from "../assests/AnnualReportsPdf/ESOP Disclosure.pdf";
import AnnualPdf3 from "../assests/AnnualReportsPdf/Business Responsibility and Sustainability Report FY 2024-25.pdf";
import AnnualPdf4 from "../assests/AnnualReportsPdf/Annual Report FY 2024-25.pdf";
import AnnualPdf5 from "../assests/AnnualReportsPdf/MGT-7 2023-24.pdf";
import AnnualPdf6 from "../assests/AnnualReportsPdf/Business Responsibility and Sustainability FY 23-24.pdf";
import AnnualPdf7 from "../assests/AnnualReportsPdf/Annual Report 2023-24.pdf";
import AnnualPdf8 from "../assests/AnnualReportsPdf/Business Responsibility and Sustainability FY 22-23.pdf";
import AnnualPdf9 from "../assests/AnnualReportsPdf/Postal ballot notice Sept 20, 2023.pdf";
import AnnualPdf10 from "../assests/AnnualReportsPdf/MGT 7 2022-23.pdf";
import AnnualPdf11 from "../assests/AnnualReportsPdf/Annual Report 2022-23.pdf";
import AnnualPdf12 from "../assests/AnnualReportsPdf/Postal Ballot Notice-November 10, 2022.pdf";
import AnnualPdf13 from "../assests/AnnualReportsPdf/Certificate under 163(2).pdf";
import AnnualPdf14 from "../assests/AnnualReportsPdf/Business Responsibility Report FY 2021-22.pdf";
import AnnualPdf15 from "../assests/AnnualReportsPdf/AGM Notice 2021-22.pdf";
import AnnualPdf16 from "../assests/AnnualReportsPdf/Annual Report 2021-22.pdf";
import AnnualPdf17 from "../assests/AnnualReportsPdf/Annual Return 2021-22.pdf";
import AnnualPdf18 from "../assests/AnnualReportsPdf/Report FY 2021-22.pdf";
import AnnualPdf19 from "../assests/AnnualReportsPdf/Postal Ballot Notice January 14, 2022.pdf";
import AnnualPdf20 from "../assests/AnnualReportsPdf/2020-21.pdf";
import AnnualPdf21 from "../assests/AnnualReportsPdf/MGT-7;2020-21.pdf";
import AnnualPdf22 from "../assests/AnnualReportsPdf/Postal Ballot Notice February 08, 2021.pdf";
import AnnualPdf23 from "../assests/AnnualReportsPdf/Postal Ballot Notice August 12, 2020.pdf";
import AnnualPdf24 from "../assests/AnnualReportsPdf/Postal Ballot Notice December 14, 2020.pdf";
import AnnualPdf25 from "../assests/AnnualReportsPdf/2019-20.pdf";
import AnnualPdf26 from "../assests/AnnualReportsPdf/MGT-9; 2019-20.pdf";
import AnnualPdf27 from "../assests/AnnualReportsPdf/MGT-9; 2018-19.pdf";
import AnnualPdf28 from "../assests/AnnualReportsPdf/MGT-7; 2018-19.pdf";
import AnnualPdf29 from "../assests/AnnualReportsPdf/2018-19.pdf";
import AnnualPdf30 from "../assests/AnnualReportsPdf/2017-18.pdf";
import AnnualPdf31 from "../assests/AnnualReportsPdf/2016-17.pdf";
import AnnualPdf32 from "../assests/AnnualReportsPdf/Green Initiative Form.pdf";
import AnnualPdf33 from "../assests/AnnualReportsPdf/2015-16.pdf";
import AnnualPdf34 from "../assests/AnnualReportsPdf/2014-15.pdf";
import AnnualPdf35 from "../assests/AnnualReportsPdf/2013-14.pdf";
import AnnualPdf36 from "../assests/AnnualReportsPdf/2012-13.pdf";
import AnnualPdf37 from "../assests/AnnualReportsPdf/2011-12.pdf";
import AnnualPdf38 from "../assests/AnnualReportsPdf/2010-11.pdf";
import AnnualPdf39 from "../assests/AnnualReportsPdf/2009-10.pdf";






import SubFinPdf1 from "../assests/SubsidiaryFinancialsPdfs/SRL Signed FS FY-25.pdf";
import SubFinPdf2 from "../assests/SubsidiaryFinancialsPdfs/AAHL, India FS FY-2025.pdf";
import SubFinPdf3 from "../assests/SubsidiaryFinancialsPdfs/ESOP Trust FS FY 2025.pdf";
import SubFinPdf4 from "../assests/SubsidiaryFinancialsPdfs/Alivira UK FS FY 2024-25.pdf";
import SubFinPdf5 from "../assests/SubsidiaryFinancialsPdfs/Alivira USA FS FY 2024-25.pdf";
import SubFinPdf6 from "../assests/SubsidiaryFinancialsPdfs/Alivira Italia Financials 2024-25.pdf";
import SubFinPdf7 from "../assests/SubsidiaryFinancialsPdfs/BREMER Pharma FS FY 2024-25.pdf";
import SubFinPdf8 from "../assests/SubsidiaryFinancialsPdfs/Phytotherapic Solutions S.L FS FY 2024-25.pdf";
import SubFinPdf9 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A. DE C.V. FS FY 2024-25.pdf";
import SubFinPdf10 from "../assests/SubsidiaryFinancialsPdfs/Laboratories Karizoo Spain FS FY 2024-25.pdf";
import SubFinPdf11 from "../assests/SubsidiaryFinancialsPdfs/Vila Viña Participacions S.L. FS FY 2024-25.pdf";
import SubFinPdf12 from "../assests/SubsidiaryFinancialsPdfs/Expeden_FS FY 2024-25.pdf";
import SubFinPdf13 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Ltda. FS FY-2024-25.pdf";
import SubFinPdf14 from "../assests/SubsidiaryFinancialsPdfs/N-Vet AB FS FY 2024-25.pdf";
import SubFinPdf15 from "../assests/SubsidiaryFinancialsPdfs/Fendingo BV FS FY 2024-25.pdf";
import SubFinPdf16 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Brasil Participacoes Ltda FS FY 2024-25.pdf";
import SubFinPdf17 from "../assests/SubsidiaryFinancialsPdfs/Fendingo SA FS FY 2024-25.pdf";
import SubFinPdf18 from "../assests/SubsidiaryFinancialsPdfs/Topkim Topkapi Ilaç premiks Sanayi Ve Ticaret A.Ş FS FY 2024-25.pdf";
import SubFinPdf19 from "../assests/SubsidiaryFinancialsPdfs/Provet Veteriner Ürünleri San. Ve Tic. A. Ş.FS FY 2024-25.pdf";
import SubFinPdf20 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited, Ireland FS FY-2024-25.pdf";
import SubFinPdf21 from "../assests/SubsidiaryFinancialsPdfs/Vila Viña Participacions S.L. FY 23-24.pdf";
import SubFinPdf22 from "../assests/SubsidiaryFinancialsPdfs/Topkim Topkapi ilac Premiks Sanayi Ve Ticaret Anonik Sirketi FY 23-24.pdf";
import SubFinPdf23 from "../assests/SubsidiaryFinancialsPdfs/Phytotherapic Solutions S. L. FY 23-24.pdf";
import SubFinPdf24 from "../assests/SubsidiaryFinancialsPdfs/Fendigo SA Belgium FY 23-24.pdf";
import SubFinPdf25 from "../assests/SubsidiaryFinancialsPdfs/Topkim March 2024 Full set V2.signed.pdf";
import SubFinPdf26 from "../assests/SubsidiaryFinancialsPdfs/VVP Stat Financials Q4 FY23-24 signed.pdf";
import SubFinPdf27 from "../assests/SubsidiaryFinancialsPdfs/Phyto Stat Financials Q4 FY23-24 signed.pdf";
import SubFinPdf28 from "../assests/SubsidiaryFinancialsPdfs/Bremer Pharma GMBH Germany FY 23-24.pdf";
import SubFinPdf29 from "../assests/SubsidiaryFinancialsPdfs/Alivira Italia S.R.L. Ltda. FY 23-24.pdf";
import SubFinPdf30 from "../assests/SubsidiaryFinancialsPdfs/N-vet FS FY 23-24.pdf";
import SubFinPdf31 from "../assests/SubsidiaryFinancialsPdfs/Kz Spain Stat Financials Q4 FY23-24 signed.pdf";
import SubFinPdf32 from "../assests/SubsidiaryFinancialsPdfs/Provet March 2024 Full set V2.signed.pdf";
import SubFinPdf33 from "../assests/SubsidiaryFinancialsPdfs/Kz Mexico Stat Financials Q4 FY23-24 signed.pdf";
import SubFinPdf34 from "../assests/SubsidiaryFinancialsPdfs/Financials Sequent Scientific ESOP trust FY 2023-24.pdf";
import SubFinPdf35 from "../assests/SubsidiaryFinancialsPdfs/Fendigo BV FS FY 23-24.pdf";
import SubFinPdf36 from "../assests/SubsidiaryFinancialsPdfs/Expeden Financials Mar-24.pdf";
import SubFinPdf37 from "../assests/SubsidiaryFinancialsPdfs/Alivira USA FS FY 23-24.pdf";
import SubFinPdf38 from "../assests/SubsidiaryFinancialsPdfs/Alivira UK Mar\'24.pdf";
import SubFinPdf39 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saúde Financials Mar-24.pdf";
import SubFinPdf40 from "../assests/SubsidiaryFinancialsPdfs/Alivira Ireland FS FY 23-24.pdf";
import SubFinPdf41 from "../assests/SubsidiaryFinancialsPdfs/Alivira Brazil Financials Mar-24.pdf";
import SubFinPdf42 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited 2023-24.pdf";
import SubFinPdf43 from "../assests/SubsidiaryFinancialsPdfs/Sequent Research Limited 2023-24.pdf";
import SubFinPdf44 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited 2022-23.pdf";
import SubFinPdf45 from "../assests/SubsidiaryFinancialsPdfs/Sequent Research Limited 2022-23.pdf";
import SubFinPdf46 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited, Ireland Financial Mar\'23.pdf";
import SubFinPdf47 from "../assests/SubsidiaryFinancialsPdfs/Alivira Italia SRL Financial Mar\'23.pdf";
import SubFinPdf48 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Brasil Participacoes Ltda Financial Mar\'23.pdf";
import SubFinPdf49 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Ltda Financial Mar\'23.pdf";
import SubFinPdf50 from "../assests/SubsidiaryFinancialsPdfs/Bremer Pharma GMBH Financial Mar\'23.pdf";
import SubFinPdf51 from "../assests/SubsidiaryFinancialsPdfs/Fendigo BV Financial Mar\'23.pdf";
import SubFinPdf52 from "../assests/SubsidiaryFinancialsPdfs/Fendigo SA Financial Mar\'23.pdf";
import SubFinPdf53 from "../assests/SubsidiaryFinancialsPdfs/Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar\'23.pdf";
import SubFinPdf54 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health USA LLC Financial Mar\'23.pdf";
import SubFinPdf55 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health UK Ltd Financial Mar\'23.pdf";
import SubFinPdf56 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar\'23.pdf";
import SubFinPdf57 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A Financial Mar\'23.pdf";
import SubFinPdf58 from "../assests/SubsidiaryFinancialsPdfs/N-Vet Financial Mar\'23.pdf";
import SubFinPdf59 from "../assests/SubsidiaryFinancialsPdfs/Phytotherapic Solutions S.L Financial Mar\'23.pdf";
import SubFinPdf60 from "../assests/SubsidiaryFinancialsPdfs/Covivet Stat Financials Q4 FY22-23 signed.pdf";
import SubFinPdf61 from "../assests/SubsidiaryFinancialsPdfs/Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar\'23.pdf";
import SubFinPdf62 from "../assests/SubsidiaryFinancialsPdfs/Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar\'23.pdf";
import SubFinPdf63 from "../assests/SubsidiaryFinancialsPdfs/Vila Viña Participacions S.L Financial Mar\'23.pdf";
import SubFinPdf64 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited 2021-22.pdf";
import SubFinPdf65 from "../assests/SubsidiaryFinancialsPdfs/Sequent Research Limited 2021-22.pdf";
import SubFinPdf66 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited, Ireland Financial Mar\'22.pdf";
import SubFinPdf67 from "../assests/SubsidiaryFinancialsPdfs/Alivira France SAS Financial Mar\'22.pdf";
import SubFinPdf68 from "../assests/SubsidiaryFinancialsPdfs/Alivira Italia SRL Financial Mar\'22.pdf";
import SubFinPdf69 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Brasil Participacoes Ltda Financial Mar\'22.pdf";
import SubFinPdf70 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Ltda Financial Mar\'22.pdf";
import SubFinPdf71 from "../assests/SubsidiaryFinancialsPdfs/Bremer Pharma GMBH Financial Mar\'22.pdf";
import SubFinPdf72 from "../assests/SubsidiaryFinancialsPdfs/Fendigo BV Financial Mar\'22.pdf";
import SubFinPdf73 from "../assests/SubsidiaryFinancialsPdfs/Fendigo SA Financial Mar\'22.pdf";
import SubFinPdf74 from "../assests/SubsidiaryFinancialsPdfs/Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar\'22.pdf";
import SubFinPdf75 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health USA LLC Financial Mar\'22.pdf";
import SubFinPdf76 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health UK Ltd Financial Mar\'22.pdf";
import SubFinPdf77 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar\'22.pdf";
import SubFinPdf78 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A Financial Mar\'22.pdf";
import SubFinPdf79 from "../assests/SubsidiaryFinancialsPdfs/N-Vet Financial Mar\'22.pdf";
import SubFinPdf80 from "../assests/SubsidiaryFinancialsPdfs/Phytotherapic Solutions S.L Financial Mar\'22.pdf";
import SubFinPdf81 from "../assests/SubsidiaryFinancialsPdfs/Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar\'22.pdf";
import SubFinPdf82 from "../assests/SubsidiaryFinancialsPdfs/Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar\'22.pdf";
import SubFinPdf83 from "../assests/SubsidiaryFinancialsPdfs/Nourrie Saude e Nutricao Animal Ltda Financial as on Mar\'22.pdf";
import SubFinPdf84 from "../assests/SubsidiaryFinancialsPdfs/Vila Viña Participacions S.L Financial Mar\'22.pdf";
import SubFinPdf85 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited 2020-21.pdf";
import SubFinPdf86 from "../assests/SubsidiaryFinancialsPdfs/Sequent Research Limited 2020-21.pdf";
import SubFinPdf87 from "../assests/SubsidiaryFinancialsPdfs/Elysian Life Sciences Private Limited 2020-21.pdf";
import SubFinPdf88 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited, Ireland.pdf";
import SubFinPdf89 from "../assests/SubsidiaryFinancialsPdfs/Alivira France SAS.pdf";
import SubFinPdf90 from "../assests/SubsidiaryFinancialsPdfs/Alivira Italia SRL.pdf";
import SubFinPdf91 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Brasil Participacoes Ltda.pdf";
import SubFinPdf92 from "../assests/SubsidiaryFinancialsPdfs/Bremer Pharma GMBH.pdf";
import SubFinPdf93 from "../assests/SubsidiaryFinancialsPdfs/Evance Saude Animal LTDA.pdf";
import SubFinPdf94 from "../assests/SubsidiaryFinancialsPdfs/Fendigo BV.pdf";
import SubFinPdf95 from "../assests/SubsidiaryFinancialsPdfs/Fendigo SA.pdf";
import SubFinPdf96 from "../assests/SubsidiaryFinancialsPdfs/Evanvet Distribidora Productos Veterinarios Ltda.pdf";
import SubFinPdf97 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health USA LLC.pdf";
import SubFinPdf98 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health UK Ltd.pdf";
import SubFinPdf99 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A. DE C.V. (Mexico).pdf";
import SubFinPdf100 from "../assests/SubsidiaryFinancialsPdfs/Laboratorios Karizoo, S.A..pdf";



// 2025 to 2026
import SubFinPdf101 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited Ireland.pdf";
import SubFinPdf102 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health Limited.pdf";
import SubFinPdf103 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health UK Ltd-2526.pdf";
import SubFinPdf104 from "../assests/SubsidiaryFinancialsPdfs/Alivira Animal Health USA LLC2526.pdf";
import SubFinPdf105 from "../assests/SubsidiaryFinancialsPdfs/Alivira Italia S.R.L.pdf";
import SubFinPdf106 from "../assests/SubsidiaryFinancialsPdfs/Alivira NV (Formerly Known as Fendigo SA).pdf";
import SubFinPdf107 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Brasil Participacoes Ltda2526.pdf";
import SubFinPdf108 from "../assests/SubsidiaryFinancialsPdfs/Alivira Saude Animal Ltda., Brazil.pdf";
import SubFinPdf109 from "../assests/SubsidiaryFinancialsPdfs/Alivira_BV (Formerly Known as Fendigo BV).pdf";
import SubFinPdf110 from "../assests/SubsidiaryFinancialsPdfs/Appco Pharma LLC, USA.pdf";
import SubFinPdf111 from "../assests/SubsidiaryFinancialsPdfs/Bremer Pharma GmBH 25-26.pdf";
import SubFinPdf112 from "../assests/SubsidiaryFinancialsPdfs/Expeden Distribuidora De Produtos Veterinarios Ltda.pdf";
import SubFinPdf113 from "../assests/SubsidiaryFinancialsPdfs/Laboratories Karizoo S.A D.E C.V (Mexico).pdf";
import SubFinPdf114 from "../assests/SubsidiaryFinancialsPdfs/Laboratories Karizoo S.A.pdf";
import SubFinPdf115 from "../assests/SubsidiaryFinancialsPdfs/N-VET AB.pdf";
import SubFinPdf116 from "../assests/SubsidiaryFinancialsPdfs/Phytotherapic Solutions S.L.pdf";
import SubFinPdf117 from "../assests/SubsidiaryFinancialsPdfs/Provet Veteriner Urunleri San Ve Tic A S.pdf";
import SubFinPdf118 from "../assests/SubsidiaryFinancialsPdfs/Topkim Topkapi IIac Premiks Sanayi Ve Ticaret A S.pdf";
import SubFinPdf119 from "../assests/SubsidiaryFinancialsPdfs/Vila Vina Participacions S.L.pdf";



// ── Imported AGM PDFs ────────────────────────────────────────────────────────
import AgmPdf1 from "../assests/AGM/Binder1.pdf";
import AgmPdf2 from "../assests/AGM/August 30, 2023.pdf";
import AgmPdf3 from "../assests/AGM/AGM_Voting Results.pdf";
import AgmPdf4 from "../assests/AGM/SEIntimationVotingResults23092021.pdf";
import AgmPdf5 from "../assests/AGM/2020-21_ August 25, 2020.pdf";
import AgmPdf6 from "../assests/AGM/August 29, 2019.pdf";
import AgmPdf7 from "../assests/AGM/September 27, 2018.pdf";
import AgmPdf8 from "../assests/AGM/BSENSEVotingResults.pdf";
import AgmPdf9 from "../assests/AGM/Sequent_Intimation_Reg_44(3)_September_23_2016.pdf";
import AgmPdf10 from "../assests/AGM/4_Sequent_AGM_Results_September 24, 2015.pdf";
import AgmPdf11 from "../assests/AGM/SEIntimationScrutnizerReport.pdf";

import AgmPdf12 from "../assests/AGM/EGM_Results_July 30, 2015.pdf";
import AgmPdf13 from "../assests/AGM/Sequent_EGM Result_March 31, 2015.pdf";
import AgmPdf14 from "../assests/AGM/Sequent_EGM Result_March 2, 2015.pdf";
import AgmPdf15 from "../assests/AGM/EGM Results_July 1, 2014.pdf";
import AgmPdf16 from "../assests/AGM/EGM Results_May 21, 2014.pdf";

import AgmPdf17 from "../assests/AGM/October 20, 2023.pdf";
import AgmPdf18 from "../assests/AGM/SEIntimationVotingResults10042022.pdf";
import AgmPdf19 from "../assests/AGM/SEIntimationVotingResults16032021.pdf";
import AgmPdf20 from "../assests/AGM/PostalBallotVotingResults.pdf";
import AgmPdf21 from "../assests/AGM/SEIntimationPostalBallotVotingResults.pdf";
import AgmPdf22 from "../assests/AGM/SEOutcomePostalBallot.pdf";
import AgmPdf23 from "../assests/AGM/Sequent_Intimation_Reg. 44(3)_Postal Ballot Results_February 1, 2016.pdf";
import AgmPdf24 from "../assests/AGM/Sequent_Clause 35A_Postal Ballot Results.pdf";
import AgmPdf25 from "../assests/AGM/Postal Ballot Results_April 23, 2014.pdf";
import AgmPdf26 from "../assests/AGM/Postal Ballot_Voting Results_Dec 10, 2013.pdf";





// ── SVG Icons ──────────────────────────────────────────────────────────────────
const PdfIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 2V8H20" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 13H15" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
        <path d="M9 17H12" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FilterIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M22 3H2l8 9.46V19l4 2V12.46L22 3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" />
        <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2" />
    </svg>
);

const SearchIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

// ── Tab Data ───────────────────────────────────────────────────────────────────

const AnnualReportsData = [
    { title: "Draft Viyash AOA", period: "2025-2026", icon: <PdfIcon />, url: DraftViyashAOA2526 },
    { title: "MGT-7", period: "2025-2026", icon: <PdfIcon />, url: MGT7_202526 },
    { title: "ESOP Disclosure 2025-26", period: "2025-2026", icon: <PdfIcon />, url: ESOPDisclosure202526 },
    { title: "Business Responsibility and Sustainability Report FY 2025-26", period: "2025-2026", icon: <PdfIcon />, url: BRSReport202526 },
    { title: "Annual Report FY 2025-26", period: "2025-2026", icon: <PdfIcon />, url: AnnualPdf202526 },


    { title: "MGT-7 2024-25", period: "2024-2025", icon: <PdfIcon />, url: AnnualPdf1 },
    { title: "ESOP Disclosure", period: "2024-2025", icon: <PdfIcon />, url: AnnualPdf2 },
    { title: "Business Responsibility and Sustainability Report FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: AnnualPdf3 },
    { title: "Annual Report FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: AnnualPdf4 },
    { title: "MGT-7 2023-24", period: "2023-2024", icon: <PdfIcon />, url: AnnualPdf5 },
    { title: "Business Responsibility and Sustainability FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: AnnualPdf6 },
    { title: "Annual Report 2023-24", period: "2023-2024", icon: <PdfIcon />, url: AnnualPdf7 },
    { title: "Business Responsibility and Sustainability FY 22-23", period: "2022-2023", icon: <PdfIcon />, url: AnnualPdf8 },
    { title: "Postal ballot notice Sept 20, 2023", period: "2022-2023", icon: <PdfIcon />, url: AnnualPdf9 },
    { title: "MGT 7 2022-23", period: "2022-2023", icon: <PdfIcon />, url: AnnualPdf10 },
    { title: "Annual Report 2022-23", period: "2022-2023", icon: <PdfIcon />, url: AnnualPdf11 },
    { title: "Postal Ballot Notice-November 10, 2022", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf12 },
    { title: "Certificate under 163(2)", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf13 },
    { title: "Business Responsibility Report FY 2021-22", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf14 },
    { title: "AGM Notice 2021-22", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf15 },
    { title: "Annual Report 2021-22", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf16 },
    { title: "Annual Return 2021-22", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf17 },
    { title: "Report FY 2021-22", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf18 },
    { title: "Postal Ballot Notice January 14, 2022", period: "2021-2022", icon: <PdfIcon />, url: AnnualPdf19 },
    { title: "2020-21", period: "2020-2021", icon: <PdfIcon />, url: AnnualPdf20 },
    { title: "MGT-7;2020-21", period: "2020-2021", icon: <PdfIcon />, url: AnnualPdf21 },
    { title: "Postal Ballot Notice February 08, 2021", period: "2020-2021", icon: <PdfIcon />, url: AnnualPdf22 },
    { title: "Postal Ballot Notice August 12, 2020", period: "2020-2021", icon: <PdfIcon />, url: AnnualPdf23 },
    { title: "Postal Ballot Notice December 14, 2020", period: "2020-2021", icon: <PdfIcon />, url: AnnualPdf24 },
    { title: "2019-20", period: "2019-2020", icon: <PdfIcon />, url: AnnualPdf25 },
    { title: "MGT-9; 2019-20", period: "2019-2020", icon: <PdfIcon />, url: AnnualPdf26 },
    { title: "MGT-9; 2018-19", period: "2018-2019", icon: <PdfIcon />, url: AnnualPdf27 },
    { title: "MGT-7; 2018-19", period: "2018-2019", icon: <PdfIcon />, url: AnnualPdf28 },
    { title: "2018-19", period: "2018-2019", icon: <PdfIcon />, url: AnnualPdf29 },
    { title: "2017-18", period: "2017-2018", icon: <PdfIcon />, url: AnnualPdf30 },
    { title: "2016-17", period: "2016-2017", icon: <PdfIcon />, url: AnnualPdf31 },
    { title: "Green Initiative Form", period: "", icon: <PdfIcon />, url: AnnualPdf32 },
    { title: "2015-16", period: "2015-2016", icon: <PdfIcon />, url: AnnualPdf33 },
    { title: "2014-15", period: "2014-2015", icon: <PdfIcon />, url: AnnualPdf34 },
    { title: "2013-14", period: "2013-2014", icon: <PdfIcon />, url: AnnualPdf35 },
    { title: "2012-13", period: "2012-2013", icon: <PdfIcon />, url: AnnualPdf36 },
    { title: "2011-12", period: "2011-2012", icon: <PdfIcon />, url: AnnualPdf37 },
    { title: "2010-11", period: "2010-2011", icon: <PdfIcon />, url: AnnualPdf38 },
    { title: "2009-10", period: "2009-2010", icon: <PdfIcon />, url: AnnualPdf39 },

];

const SubsidiaryFinancialsData = [

    { title: "Alivira Animal Health Limited Ireland", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf101 },
    { title: "Alivira Animal Health Limited", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf102 },
    { title: "Alivira Animal Health UK Ltd", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf103 },
    { title: "Alivira Animal Health USA LLC", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf104 },
    { title: "Alivira Italia S.R.L", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf105 },
    { title: "Alivira NV (Formerly Known as Fendigo SA)", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf106 },
    { title: "Alivira Saude Animal Brasil Participacoes Ltda", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf107 },
    { title: "Alivira Saude Animal Ltda., Brazil", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf108 },
    { title: "Alivira_BV (Formerly Known as Fendigo BV)", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf109 },
    { title: "Appco Pharma LLC, USA", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf110 },
    { title: "Bremer Pharma GmBH", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf111 },
    { title: "Expeden Distribuidora De Produtos Veterinarios Ltda", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf112 },
    { title: "Laboratories Karizoo S.A D.E C.V (Mexico)", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf113 },
    { title: "Laboratories Karizoo S.A", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf114 },
    { title: "N-VET AB", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf115 },
    { title: "Phytotherapic Solutions S", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf116 },
    { title: "Provet Veteriner Urunleri San Ve Tic A S", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf117 },
    { title: "Topkim Topkapi IIac Premiks Sanayi Ve Ticaret A S", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf118 },
    { title: "Vila Viña Participacions S.L", period: "2025-2026", icon: <PdfIcon />, url: SubFinPdf119 },





    { title: "SRL Signed FS FY-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf1 },
    { title: "AAHL, India FS FY-2025", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf2 },
    { title: "ESOP Trust FS FY 2025", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf3 },
    { title: "Alivira UK FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf4 },
    { title: "Alivira USA FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf5 },
    { title: "Alivira Italia Financials 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf6 },
    { title: "BREMER Pharma FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf7 },
    { title: "Phytotherapic Solutions S.L FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf8 },
    { title: "Laboratorios Karizoo, S.A. DE C.V. FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf9 },
    { title: "Laboratories Karizoo Spain FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf10 },
    { title: "Vila Viña Participacions S.L. FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf11 },
    { title: "Expeden_FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf12 },
    { title: "Alivira Saude Animal Ltda. FS FY-2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf13 },
    { title: "N-Vet AB FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf14 },
    { title: "Fendingo BV FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf15 },
    { title: "Alivira Saude Animal Brasil Participacoes Ltda FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf16 },
    { title: "Fendingo SA FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf17 },
    { title: "Topkim Topkapi Ilaç premiks Sanayi Ve Ticaret A.Ş FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf18 },
    { title: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş.FS FY 2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf19 },
    { title: "Alivira Animal Health Limited, Ireland FS FY-2024-25", period: "2024-2025", icon: <PdfIcon />, url: SubFinPdf20 },



    { title: "Vila Viña Participacions S.L. FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf21 },
    { title: "Topkim Topkapi ilac Premiks Sanayi Ve Ticaret Anonik Sirketi FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf22 },
    { title: "Phytotherapic Solutions S. L. FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf23 },
    { title: "Fendigo SA Belgium FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf24 },
    { title: "Topkim March 2024 Full set V2.signed", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf25 },
    { title: "VVP Stat Financials Q4 FY23-24 signed", period: "Q4 2023-2024", icon: <PdfIcon />, url: SubFinPdf26 },
    { title: "Phyto Stat Financials Q4 FY23-24 signed", period: "Q4 2023-2024", icon: <PdfIcon />, url: SubFinPdf27 },
    { title: "Bremer Pharma GMBH Germany FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf28 },
    { title: "Alivira Italia S.R.L. Ltda. FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf29 },
    { title: "N-vet FS FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf30 },
    { title: "Kz Spain Stat Financials Q4 FY23-24 signed", period: "Q4 2023-2024", icon: <PdfIcon />, url: SubFinPdf31 },
    { title: "Provet March 2024 Full set V2.signed", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf32 },
    { title: "Kz Mexico Stat Financials Q4 FY23-24 signed", period: "Q4 2023-2024", icon: <PdfIcon />, url: SubFinPdf33 },
    { title: "Financials Sequent Scientific ESOP trust FY 2023-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf34 },
    { title: "Fendigo BV FS FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf35 },
    { title: "Expeden Financials Mar-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf36 },
    { title: "Alivira USA FS FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf37 },
    { title: "Alivira UK Mar'24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf38 },
    { title: "Alivira Saúde Financials Mar-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf39 },
    { title: "Alivira Ireland FS FY 23-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf40 },
    { title: "Alivira Brazil Financials Mar-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf41 },
    { title: "Alivira Animal Health Limited 2023-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf42 },
    { title: "Sequent Research Limited 2023-24", period: "2023-2024", icon: <PdfIcon />, url: SubFinPdf43 },
    { title: "Alivira Animal Health Limited 2022-23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf44 },
    { title: "Sequent Research Limited 2022-23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf45 },
    { title: "Alivira Animal Health Limited, Ireland Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf46 },
    { title: "Alivira Italia SRL Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf47 },
    { title: "Alivira Saude Animal Brasil Participacoes Ltda Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf48 },
    { title: "Alivira Saude Animal Ltda Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf49 },
    { title: "Bremer Pharma GMBH Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf50 },
    { title: "Fendigo BV Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf51 },
    { title: "Fendigo SA Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf52 },
    { title: "Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf53 },
    { title: "Alivira Animal Health USA LLC Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf54 },
    { title: "Alivira Animal Health UK Ltd Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf55 },
    { title: "Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf56 },
    { title: "Laboratorios Karizoo, S.A Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf57 },
    { title: "N-Vet Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf58 },
    { title: "Phytotherapic Solutions S.L Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf59 },
    { title: "Covivet Stat Financials Q4 FY22-23 signed", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf60 },
    { title: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf61 },
    { title: "Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf62 },
    { title: "Vila Viña Participacions S.L Financial Mar'23", period: "2022-2023", icon: <PdfIcon />, url: SubFinPdf63 },
    { title: "Alivira Animal Health Limited 2021-22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf64 },
    { title: "Sequent Research Limited 2021-22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf65 },
    { title: "Alivira Animal Health Limited, Ireland Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf66 },
    { title: "Alivira France SAS Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf67 },
    { title: "Alivira Italia SRL Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf68 },
    { title: "Alivira Saude Animal Brasil Participacoes Ltda Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf69 },
    { title: "Alivira Saude Animal Ltda Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf70 },
    { title: "Bremer Pharma GMBH Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf71 },
    { title: "Fendigo BV Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf72 },
    { title: "Fendigo SA Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf73 },
    { title: "Evanvet Distribuidora De Produtos Veterinarios Ltda Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf74 },
    { title: "Alivira Animal Health USA LLC Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf75 },
    { title: "Alivira Animal Health UK Ltd Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf76 },
    { title: "Laboratorios Karizoo, S.A. DE C.V. (Mexico) Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf77 },
    { title: "Laboratorios Karizoo, S.A Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf78 },
    { title: "N-Vet Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf79 },
    { title: "Phytotherapic Solutions S.L Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf80 },
    { title: "Provet Veteriner Ürünleri San. Ve Tic. A. Ş Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf81 },
    { title: "Topkim Topkapi İlaç Premiks Sanayl Ve Ticaret. A. Ş Financials Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf82 },
    { title: "Nourrie Saude e Nutricao Animal Ltda Financial as on Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf83 },
    { title: "Vila Viña Participacions S.L Financial Mar'22", period: "2021-2022", icon: <PdfIcon />, url: SubFinPdf84 },
    { title: "Alivira Animal Health Limited 2020-21", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf85 },
    { title: "Sequent Research Limited 2020-21", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf86 },
    { title: "Elysian Life Sciences Private Limited 2020-21", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf87 },
    { title: "Alivira Animal Health Limited, Ireland", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf88 },
    { title: "Alivira France SAS", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf89 },
    { title: "Alivira Italia SRL", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf90 },
    { title: "Alivira Saude Animal Brasil Participacoes Ltda", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf91 },
    { title: "Bremer Pharma GMBH", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf92 },
    { title: "Evance Saude Animal LTDA", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf93 },
    { title: "Fendigo BV", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf94 },
    { title: "Fendigo SA", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf95 },
    { title: "Evanvet Distribidora Productos Veterinarios Ltda", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf96 },
    { title: "Alivira Animal Health USA LLC", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf97 },
    { title: "Alivira Animal Health UK Ltd", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf98 },
    { title: "Laboratorios Karizoo, S.A. DE C.V. (Mexico)", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf99 },
    { title: "Laboratorios Karizoo, S.A.", period: "2020-2021", icon: <PdfIcon />, url: SubFinPdf100 },

];

const AGMPostalBallotData = [
    { period: "2024-2025", year: "2024-2025", type: "AGM", title: "AGM Results - August 8, 2025", date: "August 8, 2025", icon: <PdfIcon />, url: AgmPdf1 },
    { period: "2023-2024", year: "2023-2024", type: "AGM", title: "AGM Results - August 30, 2023", date: "August 30, 2023", icon: <PdfIcon />, url: AgmPdf2 },
    { period: "2022-2023", year: "2022-2023", type: "AGM", title: "AGM Results - September 20, 2022", date: "September 20, 2022", icon: <PdfIcon />, url: AgmPdf3 },
    { period: "2021-2022", year: "2021-2022", type: "AGM", title: "AGM Results - September 21, 2021", date: "September 21, 2021", icon: <PdfIcon />, url: AgmPdf4 },
    { period: "2020-2021", year: "2020-2021", type: "AGM", title: "AGM Results - August 25, 2020", date: "August 25, 2020", icon: <PdfIcon />, url: AgmPdf5 },
    { period: "2019-2020", year: "2019-2020", type: "AGM", title: "AGM Results - August 29, 2019", date: "August 29, 2019", icon: <PdfIcon />, url: AgmPdf6 },
    { period: "2018-2019", year: "2018-2019", type: "AGM", title: "AGM Results - September 27, 2018", date: "September 27, 2018", icon: <PdfIcon />, url: AgmPdf7 },
    { period: "2017-2018", year: "2017-2018", type: "AGM", title: "AGM Results - September 26, 2017", date: "September 26, 2017", icon: <PdfIcon />, url: AgmPdf8 },
    { period: "2016-2017", year: "2016-2017", type: "AGM", title: "AGM Results - September 23, 2016", date: "September 23, 2016", icon: <PdfIcon />, url: AgmPdf9 },
    { period: "2015-2016", year: "2015-2016", type: "AGM", title: "AGM Results - September 24, 2015", date: "September 24, 2015", icon: <PdfIcon />, url: AgmPdf10 },
    { period: "2014-2015", year: "2014-2015", type: "AGM", title: "AGM Results - September 29, 2014", date: "September 29, 2014", icon: <PdfIcon />, url: AgmPdf11 },

    { period: "2015-2016", year: "2015-2016", type: "EGM", title: "EGM Results - July 30, 2015", date: "July 30, 2015", icon: <PdfIcon />, url: AgmPdf12 },
    { period: "2014-2015", year: "2014-2015", type: "EGM", title: "EGM Results - March 31, 2015", date: "March 31, 2015", icon: <PdfIcon />, url: AgmPdf13 },
    { period: "2014-2015", year: "2014-2015", type: "EGM", title: "EGM Results - March 2, 2015", date: "March 2, 2015", icon: <PdfIcon />, url: AgmPdf14 },
    { period: "2014-2015", year: "2014-2015", type: "EGM", title: "EGM Results - July 01, 2014", date: "July 01, 2014", icon: <PdfIcon />, url: AgmPdf15 },
    { period: "2014-2015", year: "2014-2015", type: "EGM", title: "EGM Results - May 21, 2014", date: "May 21, 2014", icon: <PdfIcon />, url: AgmPdf16 },

    { period: "2023-2024", year: "2023-2024", type: "Postal Ballot", title: "Postal Ballot Results - October 20, 2023", date: "October 20, 2023", icon: <PdfIcon />, url: AgmPdf17 },
    { period: "2022-2023", year: "2022-2023", type: "Postal Ballot", title: "Postal Ballot Results - April 10, 2022", date: "April 10, 2022", icon: <PdfIcon />, url: AgmPdf18 },
    { period: "2020-2021", year: "2020-2021", type: "Postal Ballot", title: "Postal Ballot Results - March 16, 2021", date: "March 16, 2021", icon: <PdfIcon />, url: AgmPdf19 },
    { period: "2020-2021", year: "2020-2021", type: "Postal Ballot", title: "Postal Ballot Results - January 19, 2021", date: "January 19, 2021", icon: <PdfIcon />, url: AgmPdf20 },
    { period: "2020-2021", year: "2020-2021", type: "Postal Ballot", title: "Postal Ballot Results - September 18, 2020", date: "September 18, 2020", icon: <PdfIcon />, url: AgmPdf21 },
    { period: "2016-2017", year: "2016-2017", type: "Postal Ballot", title: "Postal Ballot Results - March 24, 2017", date: "March 24, 2017", icon: <PdfIcon />, url: AgmPdf22 },
    { period: "2015-2016", year: "2015-2016", type: "Postal Ballot", title: "Postal Ballot Results - February 1, 2016", date: "February 1, 2016", icon: <PdfIcon />, url: AgmPdf23 },
    { period: "2014-2015", year: "2014-2015", type: "Postal Ballot", title: "Postal Ballot Results - August 2, 2014", date: "August 2, 2014", icon: <PdfIcon />, url: AgmPdf24 },
    { period: "2014-2015", year: "2014-2015", type: "Postal Ballot", title: "Postal Ballot Results - April 23, 2014", date: "April 23, 2014", icon: <PdfIcon />, url: AgmPdf25 },
    { period: "2013-2014", year: "2013-2014", type: "Postal Ballot", title: "Postal Ballot Results - December 10, 2013", date: "December 10, 2013", icon: <PdfIcon />, url: AgmPdf26 }
];

// ── Pagination config ──────────────────────────────────────────────────────────
const ITEMS_PER_PAGE = 24;

// ── Main Component ─────────────────────────────────────────────────────────────
const AnnualReports = () => {
    const [activeTab, setActiveTab] = useState("Annual Reports");
    const [selectedYear, setSelectedYear] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const tabs = [
        { id: "Annual Reports", label: "Annual Reports", count: AnnualReportsData.length },
        { id: "Subsidiary Financials", label: "Subsidiary Financials", count: SubsidiaryFinancialsData.length },
        { id: "AGM/ Postal Ballot", label: "AGM/ Postal Ballot", count: AGMPostalBallotData.length },
    ];

    const getActiveData = () => {
        switch (activeTab) {
            case "Annual Reports": return AnnualReportsData;
            case "Subsidiary Financials": return SubsidiaryFinancialsData;
            case "AGM/ Postal Ballot": return AGMPostalBallotData;
            default: return [];
        }
    };

    const activeData = getActiveData();

    const uniqueYears = useMemo(() => {
        const allPeriods = activeData.map((r) => r.period).filter(Boolean);
        return ["All", ...Array.from(new Set(allPeriods)).sort().reverse()];
    }, [activeTab, activeData]);

    const filteredReports = useMemo(() => {
        return activeData.filter((report) => {
            const yearMatch = selectedYear === "All" || report.period === selectedYear;
            const searchMatch = !searchQuery || report.title.toLowerCase().includes(searchQuery.toLowerCase());
            return yearMatch && searchMatch;
        });
    }, [activeData, selectedYear, searchQuery]);

    const totalPages = Math.ceil(filteredReports.length / ITEMS_PER_PAGE);

    const paginatedReports = useMemo(() => {
        const start = (currentPage - 1) * ITEMS_PER_PAGE;
        return filteredReports.slice(start, start + ITEMS_PER_PAGE);
    }, [filteredReports, currentPage]);

    const groupedReports = useMemo(() => {
        if (selectedYear !== "All" || searchQuery) return null;
        const groups = {};
        paginatedReports.forEach((report) => {
            const key = report.period || "General";
            if (!groups[key]) groups[key] = [];
            groups[key].push(report);
        });
        return Object.entries(groups).sort((a, b) => {
            if (a[0] === "General") return 1;
            if (b[0] === "General") return -1;
            return b[0].localeCompare(a[0]);
        });
    }, [paginatedReports, selectedYear, searchQuery]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSelectedYear("All");
        setSearchQuery("");
        setCurrentPage(1);
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
        setCurrentPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const hasYearFilter = activeData.some((r) => r.period);

    return (
        <div className="ar-page">
            {/* HERO */}
            <section className="ar-hero">
                <div className="ar-hero-content">
                    <h1>Annual Reports & Financials</h1>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>
                        Access annual reports, subsidiary financials, AGM notices, and postal ballot documents
                        of Sequent Scientific Limited.
                    </p>
                </div>
            </section>

            {/* TABS */}
            <div className="ar-tabs-strip">
                <nav className="ar-tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`ar-tab ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => handleTabChange(tab.id)}
                        >
                            <span className="ar-tab-label">{tab.label}</span>
                            {/* <span className="ar-tab-count">{tab.count}</span> */}
                        </button>
                    ))}
                </nav>
            </div>

            {/* CONTENT */}
            <div className="ar-content">
                <div className="ar-content-inner">
                    {/* FILTER BAR */}
                    <div className="ar-filter-bar">
                        <div className="ar-filter-left">
                            <h2 className="ar-section-title">
                                {tabs.find((t) => t.id === activeTab)?.label}
                            </h2>
                            {/* <span className="ar-result-count">
                                {filteredReports.length} document{filteredReports.length !== 1 ? "s" : ""}
                            </span> */}
                        </div>

                        {activeData.length > 0 && (
                            <div className="ar-filter-right">
                                <div className="ar-search-wrapper">
                                    <SearchIcon />
                                    <input
                                        type="text"
                                        placeholder="Search documents..."
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                        className="ar-search-input"
                                    />
                                    {searchQuery && (
                                        <button
                                            className="ar-search-clear"
                                            onClick={() => { setSearchQuery(""); setCurrentPage(1); }}
                                        >
                                            ×
                                        </button>
                                    )}
                                </div>

                                {hasYearFilter && (
                                    <>
                                        <div className="ar-filter-icon">
                                            <FilterIcon />
                                            <span>Filter</span>
                                        </div>
                                        <div className="ar-select-wrapper">
                                            <CalendarIcon />
                                            <select value={selectedYear} onChange={handleYearChange} className="ar-select">
                                                {uniqueYears.map((year) => (
                                                    <option key={year} value={year}>
                                                        {year === "All" ? "All Years" : `FY ${year}`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ACTIVE FILTERS */}
                    {(selectedYear !== "All" || searchQuery) && activeData.length > 0 && (
                        <div className="ar-active-filters">
                            {selectedYear !== "All" && (
                                <span className="ar-filter-chip">
                                    FY {selectedYear}
                                    <button onClick={() => { setSelectedYear("All"); setCurrentPage(1); }}>×</button>
                                </span>
                            )}
                            {searchQuery && (
                                <span className="ar-filter-chip">
                                    Search: "{searchQuery}"
                                    <button onClick={() => { setSearchQuery(""); setCurrentPage(1); }}>×</button>
                                </span>
                            )}
                            <button
                                className="ar-clear-all"
                                onClick={() => { setSelectedYear("All"); setSearchQuery(""); setCurrentPage(1); }}
                            >
                                Clear all
                            </button>
                        </div>
                    )}

                    {/* REPORTS */}
                    {filteredReports.length > 0 ? (
                        <>
                            {groupedReports ? (
                                <div className="ar-grouped-reports">
                                    {groupedReports.map(([period, reports]) => (
                                        <div key={period} className="ar-report-group">
                                            <div className="ar-group-header">
                                                <h3 className="ar-group-title">
                                                    <CalendarIcon />
                                                    {period === "General" ? "General" : `FY ${period}`}
                                                </h3>
                                                <span className="ar-group-count">
                                                    {reports.length} file{reports.length !== 1 ? "s" : ""}
                                                </span>
                                            </div>
                                            <div className="ar-reports-grid">
                                                {reports.map((report, index) => (
                                                    <div key={index} className="ar-report-card">
                                                        <div className="ar-card-top">
                                                            <div className="ar-card-icon-wrapper">
                                                                {report.icon || <PdfIcon />}
                                                            </div>
                                                        </div>
                                                        <div className="ar-card-body">
                                                            <h4 className="ar-card-title">{report.title}</h4>
                                                        </div>
                                                        <div className="ar-card-footer">
                                                            {report.period && (
                                                                <span className="ar-card-period">{report.period}</span>
                                                            )}
                                                            <button
                                                                className="ar-download-btn"
                                                                title="Download"
                                                                onClick={() => report.url && window.open(report.url, "_blank")}
                                                            >
                                                                <DownloadIcon />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="ar-reports-grid ar-reports-grid-flat">
                                    {paginatedReports.map((report, index) => (
                                        <div key={index} className="ar-report-card">
                                            <div className="ar-card-top">
                                                <div className="ar-card-icon-wrapper">
                                                    {report.icon || <PdfIcon />}
                                                </div>
                                            </div>
                                            <div className="ar-card-body">
                                                <h4 className="ar-card-title">{report.title}</h4>
                                            </div>
                                            <div className="ar-card-footer">
                                                {report.period && (
                                                    <span className="ar-card-period">{report.period}</span>
                                                )}
                                                <button
                                                    className="ar-download-btn"
                                                    title="Download"
                                                    onClick={() => report.url && window.open(report.url, "_blank")}
                                                >
                                                    <DownloadIcon />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* PAGINATION */}
                            {totalPages > 1 && (
                                <div className="ar-pagination">
                                    <button
                                        className="ar-page-btn ar-page-nav"
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                    >
                                        ← Previous
                                    </button>
                                    <div className="ar-page-numbers">
                                        {getPageNumbers()[0] > 1 && (
                                            <>
                                                <button className="ar-page-btn" onClick={() => setCurrentPage(1)}>1</button>
                                                {getPageNumbers()[0] > 2 && <span className="ar-page-ellipsis">…</span>}
                                            </>
                                        )}
                                        {getPageNumbers().map((page) => (
                                            <button
                                                key={page}
                                                className={`ar-page-btn ${currentPage === page ? "active" : ""}`}
                                                onClick={() => setCurrentPage(page)}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                        {getPageNumbers()[getPageNumbers().length - 1] < totalPages && (
                                            <>
                                                {getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1 && (
                                                    <span className="ar-page-ellipsis">…</span>
                                                )}
                                                <button className="ar-page-btn" onClick={() => setCurrentPage(totalPages)}>
                                                    {totalPages}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        className="ar-page-btn ar-page-nav"
                                        disabled={currentPage === totalPages}
                                        onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                    >
                                        Next →
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="ar-no-results">
                            <div className="ar-no-results-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M9 14L15 8M9 8L15 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                        stroke="#D1D5DB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                            <h3>No documents found</h3>
                            <p>
                                {activeData.length === 0
                                    ? "Documents for this section will be available soon."
                                    : "Try adjusting your filters or search query to find what you're looking for."}
                            </p>
                            {activeData.length > 0 && (
                                <button
                                    className="ar-reset-btn"
                                    onClick={() => { setSelectedYear("All"); setSearchQuery(""); setCurrentPage(1); }}
                                >
                                    Reset Filters
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AnnualReports;